module.exports = __webpack_public_path__ + "static/img/logo2.585cb35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/logo2.png
// module id = PGHQ
// module chunks = 1